import { Inbox } from "lucide-react";

export function EmptyState({ title = "Keine Daten", description = "", icon: Icon = Inbox, action = null, testid = "empty-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-start justify-center rounded-xl border border-dashed border-fundio-border bg-white px-8 py-14 text-left">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg border border-fundio-border bg-fundio-subtle">
        <Icon className="h-6 w-6 text-fundio-faint" />
      </div>
      <h3 className="font-display text-lg font-medium text-fundio-ink">{title}</h3>
      {description && <p className="mt-1 max-w-md text-sm text-fundio-muted">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
